import { GamepadSquareIcon } from './GamepadSquareIcon';

/**
 * author: Google
 * id 0FE0FB42-286B-4D56-AE93-6D93EA514C4B
 * name gamepad-square
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-square.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerSquareIcon = GamepadSquareIcon;
export default ControllerSquareIcon